import React from "react"

import { makeStyles } from "@material-ui/core/styles"

import flexProLogo from "../../../images/logos/FlexPro/Access_Pay_Day_Logo_Transparent.png"

interface Props {
  size?: number | string
  width?: number | string
  height?: number | string
}

export const useStyles = makeStyles({
  logo: (props: Props) => ({
    maxWidth: props.width || props.size || "100%",
    maxHeight: props.height || props.size || "100%",
  }),
})

const Logo: React.FC<Props> = (props: Props) => {
  const classes = useStyles(props)
  return <img src={flexProLogo} className={classes.logo} />
}

export default Logo
